import { Card } from "@material-ui/core";
import { tokens } from "app/theme";
import { Link } from "react-router-dom";

export function CountCard({
  title,
  count,
  path,
  suffix = "",
  sub,
}: {
  title: string;
  count: number;
  path?: string;
  suffix?: string;
  sub?: string;
}) {
  const body = (
    <>
      <div
        style={{
          font: `500 10px/1 ${tokens.fontMono}`,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          color: tokens.fg3,
        }}
      >
        {title}
      </div>
      <div
        style={{
          font: `500 40px/1 ${tokens.fontMono}`,
          color: tokens.fg1,
          letterSpacing: "-0.01em",
          marginTop: 12,
        }}
      >
        {count.toLocaleString()}
        {suffix}
      </div>
      {sub ? (
        <div
          style={{
            font: `400 11px/1 ${tokens.fontMono}`,
            color: tokens.fg3,
            marginTop: 8,
          }}
        >
          {sub}
        </div>
      ) : null}
    </>
  );
  const contentStyle = {
    display: "block",
    padding: "14px 16px",
    textDecoration: "none",
    color: "inherit",
    minWidth: 150,
  };
  return (
    <Card style={{ height: "100%" }}>
      {path ? (
        <Link to={path} style={contentStyle}>
          {body}
        </Link>
      ) : (
        <div style={contentStyle}>{body}</div>
      )}
    </Card>
  );
}
